import React from 'react';
import Slider from 'components/ui/Slider(new)';
import type { QuestionInputProps } from '../types/questionnaire';

/**
 * Shared scale input component for questionnaires
 * Handles: question_scale
 */
export const ScaleInput: React.FC<QuestionInputProps> = ({
  question,
  value,
  onChange,
  disabled = false,
}) => {
  const { startingPoint = 0, scaleLabels = [], scaleSteps = 10 } = question;

  const marks: Array<{ value: number; label: string }> = scaleLabels;

  return (
    <div style={{ padding: 10 }}>
      <Slider
        value={value ?? startingPoint}
        onChange={(_event: any, newValue: number | number[]) =>
          onChange(newValue)
        }
        defaultValue={value ?? startingPoint}
        min={startingPoint}
        max={startingPoint + scaleSteps - 1}
        marks={marks as any}
        withThumb={value !== undefined}
        disabled={disabled}
        style={{
          opacity: disabled ? 0.6 : 1,
          pointerEvents: disabled ? 'none' : 'auto',
        }}
      />
    </div>
  );
};
